import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withSnackbar } from 'notistack';
import LockIcon from '@material-ui/icons/Lock';

import {
  Card,
  CardContent,
  Typography,
  CircularProgress,
} from '@material-ui/core';

import { useDispatch, useSelector } from 'react-redux';

import { LocalStorage } from '~/helpers';
import { getIsSubApp } from '~/selectors';
import { setUserData } from '~/thunks';

import userRequest from '../../../api/user';
import styles from './styles';
import Page from '../../../components/Page';
import LoginForm from '../../forms/Login';

function Login({ enqueueSnackbar }) {
  const classes = styles();
  const history = useHistory();

  const dispatch = useDispatch();
  const isSubApp = useSelector(getIsSubApp);

  const handleSubmit = async (values) => {
    try {
      const { token, user } = await userRequest.signIn(values);

      if (!token || !user) {
        enqueueSnackbar('Failed to login', { variant: 'error' });

        return;
      }

      LocalStorage.setToken(token);
      LocalStorage.setUser(user);

      dispatch(
        setUserData({
          ...user,
          isAuthorized: true,
        })
      );
      history.push('/');
    } catch (error) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  };

  if (isSubApp) {
    return (
      <Page className={classes.root} title="Login">
        <CircularProgress />
      </Page>
    );
  }

  return (
    <Page className={classes.root} title="Login">
      <Card className={classes.card}>
        <CardContent style={{ flex: 1 }} className={classes.content}>
          <LockIcon className={classes.icon} />

          <Typography gutterBottom variant="h3">
            Sign in
          </Typography>
          <Typography variant="subtitle2">
            Sign in on the internal platform
          </Typography>
          <LoginForm
            handleSubmit={handleSubmit}
            className={classes.loginForm}
          />
        </CardContent>
      </Card>
    </Page>
  );
}

Login.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
};

export default withSnackbar(Login);
